// upskillingService.js

import apiClient from "./apiClient";
import {
  getEmail,
  getOrgCode,
  getOrgName,
  getUserName,
} from "../components/shared/util";
const UPSKILLING_PATH = "/api/v3/upskilling";

const ALLOWED_URGENCY_VALUES = ["All", "Critical", "High", "Moderate", "Low"];

const sanitizeUrgencyValues = (urgency = []) => {
  const values = Array.isArray(urgency) ? urgency : [urgency];

  const validValues = values.filter((value) =>
    ALLOWED_URGENCY_VALUES.includes(value),
  );

  const actualUrgencies = validValues.filter((value) => value !== "All");

  return actualUrgencies.length > 0 ? [...new Set(actualUrgencies)] : ["All"];
};

export const getUpSkillingApi = async (data = {}) => {
  const payload = {
    ...data,
    urgency: sanitizeUrgencyValues(data.urgency),
  };

  console.log(
    "Final getAllUpskilledPeople payload:",
    JSON.stringify(payload, null, 2),
  );

  return await apiClient.post(
    `${UPSKILLING_PATH}/getAllUpskilledPeople`,
    payload,
  );
};

export const getLeadershipPotentialsApi = async (data) => {
  const response = await apiClient.post(
    `${UPSKILLING_PATH}/getLeadershipPotentials`,
    data,
  );
  return response.data;
};

export const createLeadershipNominationApi = async (data) => {
  const response = await apiClient.post(
    `${UPSKILLING_PATH}/createLeadershipNomination`,
    data,
  );
  return response.data;
};

export const getMobilityOpportunitiesApi = async (data) => {
  const response = await apiClient.post(
    `${UPSKILLING_PATH}/getMobilityOpportunities`,
    data,
  );
  return response.data;
};

export const createMobilityRecommendationApi = async (data) => {
  const response = await apiClient.post(
    `${UPSKILLING_PATH}/createMobilityRecommendation`,
    data,
  );
  return response.data;
};

export const getLearningPathApi = async (data) => {
  const response = await apiClient.post(
    `${UPSKILLING_PATH}/getLearningPath`,
    data,
  );
  return response.data;
};
